import axios from "axios";
import { getApiBaseUrl } from "../config/api";
import { getAuthToken } from "../stores/authStore";
import { clearSession } from "./authSession";

const apiClient = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 30000,
});

/** Rutas públicas de lead sin sesión: no enviar Bearer (CORS / enlaces firmados / registro welcome). */
function isPublicLeadAnonymousRequest(config) {
  const method = String(config.method || "get").toLowerCase();
  const u = String(config.url || "");
  if (method === "get" && (u.includes("/lead/welcome-check/") || u.includes("/lead/verify/"))) {
    return true;
  }
  if (
    method === "post" &&
    (u === "/lead/register" ||
      u.endsWith("/lead/register") ||
      u.includes("/lead/register/check-nickname"))
  ) {
    return true;
  }
  return false;
}

apiClient.interceptors.request.use((config) => {
  const base = getApiBaseUrl();
  config.baseURL = base || undefined;
  const token = getAuthToken();
  if (token && !isPublicLeadAnonymousRequest(config)) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    delete config.headers.Authorization;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    if (status === 401) {
      const path = typeof window !== "undefined" ? window.location.pathname : "";
      const publicPrefixes = ["/auth", "/forgot-password", "/reset-password"];
      const isPublic =
        publicPrefixes.some((p) => path === p || path.startsWith(`${p}/`)) ||
        path.includes("/lead/verify/") ||
        path.includes("/lead/welcome-check") ||
        path.startsWith("/rules");
      if (!isPublic) {
        clearSession();
        if (typeof window !== "undefined") {
          window.location.replace("/auth");
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
